export enum PaymentOperationTypeId {
  INCOME = 'in',
  EXPENSE = 'out',
}
